import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3q3fv8vc8q: FaireBrandEntity = {
  token: "b_3q3fv8vc8q",
  type: "brand",
  name: "SIGMA STAR",
  avatarUrl:
    "https://cdn.faire.com/fastly/84b99015340e684ab086e582fc6f4b51ebbe0bd96129c062c6dc4292f7c6cfa4.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/f1571c52ce093228ee54c7d1187797bbb6a27c2e23f17cb962be317f58eb0eca.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/84b99015340e684ab086e582fc6f4b51ebbe0bd96129c062c6dc4292f7c6cfa4.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f1571c52ce093228ee54c7d1187797bbb6a27c2e23f17cb962be317f58eb0eca.jpeg",
  location: "Dallas, TX, USA",
  minimumOrderDollars: 100,
  rating: 0,
  reviewCount: 0,
  isInsider: true,
  description:
    "For many years Sigma Star has strived to import affordable items that our customers can resell at margins that allow them to not only survive but thrive.  Our products have, of course, greatly changed over the years, but we continue to focus on our objective to bring quality goods that sell quickly and profitably.  Because we are based in Texas, we offer a wide selection of Texas souvenirs, including keychains, magnets and other items.  We also offer many other items for our wholesale customers in our physical location in Dallas, TX.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:16.380Z",
    importedBy: "entity-db-cli",
  },
};
